import React, { useEffect } from "react";
import styles from "./HeaderDropdownProducts.module.scss";
import { Link, NavLink } from "react-router-dom";
import LogoIcon from "../../../assets/images/site-logo/logo.svg";

interface HeaderDropdownProps {
  activeCategory: any[];
  hoveredCategory: string | null;
  activeItems: any[] | null;
  setHoveredCategory: (name: string | null) => void;
  setActiveItems: (items: any[] | null) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  path: string;
  translations?: any;
}

const HeaderDropdownProducts: React.FC<HeaderDropdownProps> = ({
  activeCategory,
  hoveredCategory,
  activeItems,
  setHoveredCategory,
  setActiveItems,
  onMouseEnter,
  onMouseLeave,
  path,
  translations,
}) => {
  useEffect(() => {
    if (path === "products" && activeCategory.length > 0) {
      setHoveredCategory(activeCategory[0].name);
      setActiveItems(activeCategory[0]?.children || null);
    } else if (path === "services" && activeCategory.length > 0) {
      setHoveredCategory(activeCategory[0].name);
      setActiveItems(activeCategory[0]?.services || null);
    }
  }, [activeCategory, path, setActiveItems, setHoveredCategory]);

  return (
    <div
      className={styles.dropdownContainer}
      style={{ height: path === "services" ? "50vh" : "75vh" }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.dropDownContent}>
        {path === "services" ? (
          <>
            <div className={styles.servicesLeftContent}>
              <Link to={"services"} className={styles.servicesLeftTitle}>
                {translations?.services}
              </Link>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 24 }}
              >
                <img
                  className={styles.servicesLeftImg}
                  src={LogoIcon}
                  alt={LogoIcon}
                />
                {/* <p className={styles.servicesLeftText}>
                  {translations?.our_slogan}
                </p> */}
              </div>
            </div>

            <div className={styles.servicesRightContent}>
              {activeCategory.map((category) => (
                <div key={category.id} className={styles.serviceGroup}>
                  <h3 className={styles.serviceGroupTitle}>{category.name}</h3>
                  <div className={styles.serviceItemsContainer}>
                    {category.services?.map((service: any) => (
                      <div key={service.id} className={styles.serviceItem}>
                        {/* <NavLink
                          // to={`/itemRepair/${service.id}`}
                          to="/repair"
                          className={styles.serviceLink}
                        >
                          {service.name}
                        </NavLink> */}

                        <NavLink
                          to={category.id === 25 ? "/repair" : "/install"}
                          className={styles.serviceLink}
                        >
                          {service.name}
                        </NavLink>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <ul className={styles.categoryItems}>
              {activeCategory.map((category) => (
                <li
                  key={category.id}
                  className={`${styles.dropdown_category} ${hoveredCategory === category.name ? styles.active : ""}`}
                  onMouseEnter={() => {
                    setHoveredCategory(category.name);
                    setActiveItems(category.children || null);
                  }}
                >
                  <NavLink
                    to={`/products/${category.slug || category.id}`}
                    className={styles.categoryName}
                  >
                    {category.image_url && <img src={category.image_url} alt="" className={styles.categoryIcon} />}
                    {category.name}
                  </NavLink>
                </li>
              ))}
            </ul>

            <div className={styles.dropDownLeft}>
              
              <div className={styles.columnContainer}>
                {activeItems?.map((subCategory) => (
                  <div key={subCategory.id} className={styles.column}>
                    <h3 className={styles.columnTitle}>
                      <NavLink to={`/products/${subCategory.slug || subCategory.id}`}>
                        {subCategory.name}
                      </NavLink>
                    </h3>
                    <ul className={styles.columnItems}>
                      {subCategory.children?.map((item: any) => (
                        <li key={item.id} className={styles.columnItem}>
                          <NavLink to={`/products/${item.slug || item.id}`}>
                            {item.name}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderDropdownProducts;
